<app-traitement-data titre="Pression auto (min - max)"
    [sousTitre]="patient!.tableauDeBord?.pressionMinimale?.date | aLaDateDu"
    [statut]="patient!.tableauDeBord?.pressionMinimale?.value ? 'info' : 'warning'">
    {{ (patient!.tableauDeBord?.pressionMinimale?.value | pression) ?? 'Ø' }} - {{
    (patient!.tableauDeBord?.pressionMaximale?.value | pression) }}
</app-traitement-data>